import { LabCustomerUserInsurance as _LabCustomerUserInsurance } from '@team-milva/lab-models/user'
import type { ILabCustomerUserInsurance } from '@team-milva/lab-models/user'
import type { DeepPartial } from '@/types/types'
import type { ITermsOfUseAcceptance } from './LabCustomerUserBusiness'

// An insurance customer's user (MIL-402). Same app-local `termsAccepted` field as
// LabCustomerUserBusiness, until MIL-136 moves it into the models.
export class LabCustomerUserInsurance extends _LabCustomerUserInsurance {
  termsAccepted: ITermsOfUseAcceptance | null

  constructor(
    params: DeepPartial<ILabCustomerUserInsurance> & {
      termsAccepted?: ITermsOfUseAcceptance | null
    } = {}
  ) {
    super(params)
    this.termsAccepted = params.termsAccepted ?? null
  }
}
